module.exports = __webpack_public_path__ + "a3715e4a4520b786391cdcf219ff5955.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-29.png
// module id = 2123
// module chunks = 0